export interface Tomo {
  num: string
  title: string
  range: string
}
export interface Bono {
  num: string
  name: string
  /** Beneficio en una línea. */
  role: string
}
export interface Faq {
  q: string
  a: string
}

/**
 * Formato monetario único de la landing: siempre "$00.000".
 */
export const PRICE = {
  previous: '$39.990',
  current: '$19.990',
  note: 'Pago único · Acceso digital inmediato',
} as const

/** Con información dispersa → Con las 200 fórmulas. */
export const TRANSFORM_BEFORE: string[] = [
  'No sabés qué proporciones usar.',
  'El jabón queda opaco o transpira.',
  'Se rompe al desmoldar o pierde el aroma.',
  'Gastás insumos probando a ciegas.',
]

export const TRANSFORM_AFTER: string[] = [
  'Fórmulas con cantidades exactas.',
  'Sabés qué base y qué aditivos usar.',
  'Temperaturas y procedimiento paso a paso.',
  'Detectás y corregís errores.',
]

/** Criterios con los que se elige qué fórmula fabricar dentro de la biblioteca. */
export const LIBRARY_CRITERIA: string[] = [
  'Dificultad',
  'Insumos',
  'Inversión',
  'Estilo',
  'Tipo de piel',
  'Ocasión',
  'Producción en tandas',
  'Formato de venta',
]

/** Las 10 familias que agrupan las 200 fórmulas. */
export const SOAP_FAMILIES: string[] = [
  'Uso Diario & Piel Sensible',
  'Glicerina Transparente & Capas',
  'Exfoliantes & Avena',
  'Botánicos con Hierbas y Flores',
  'Terapéuticos & Cuidado Específico',
  'Aromaterapia, Spa & Relax',
  'Decorativos & Moldes de Fantasía',
  'Souvenirs & Producción en Serie',
  'Jabones de Estación & Regalos',
  'Packs y Líneas para Vender',
]

/** Los 4 tomos de la colección. */
export const TOMOS: Tomo[] = [
  { num: '1', title: 'Jabones para el Día a Día', range: 'Fórmulas 001–050' },
  { num: '2', title: 'Jabones Especiales y Terapéuticos', range: 'Fórmulas 051–100' },
  { num: '3', title: 'Jabones Creativos y Decorativos', range: 'Fórmulas 101–150' },
  { num: '4', title: 'Jabones para Ocasiones y Negocio', range: 'Fórmulas 151–200' },
]

/** Lo que contiene cada ficha de fórmula. */
export const FORMULA_FIELDS: string[] = [
  'Insumos',
  'Cantidades y proporciones',
  'Base de glicerina',
  'Molde y formato',
  'Aromas y esencias',
  'Colorantes y aditivos',
  'Temperaturas',
  'Paso a paso',
  'Desmolde y reposo',
  'Terminación',
  'Errores y correcciones',
  'Consejo de venta',
]

/** Los 5 bonos incluidos gratis con la compra. */
export const BONOS: Bono[] = [
  {
    num: '1',
    name: 'Guía de Primeras Ventas: Cómo Vender Tus Primeros Jabones Desde Casa',
    role: 'De la cocina a tu primer cliente.',
  },
  {
    num: '2',
    name: 'Instagram Artesanal: Perfil Listo para Mostrar y Vender Jabones',
    role: 'Mostralos y que se vendan solos.',
  },
  {
    num: '3',
    name: 'Mapa de Insumos y Proveedores para Jabones de Glicerina en Argentina',
    role: 'Dónde comprar y a qué precio.',
  },
  {
    num: '4',
    name: 'Calculadora Simple de Costos y Precio Sugerido para Jabones Artesanales',
    role: 'Calculá bien. Ganá más.',
  },
  {
    num: '5',
    name: 'Plan de Acción 48 Horas: De Cero a Tu Primer Jabón Terminado',
    role: 'Arrancá este fin de semana.',
  },
]

/** Resumen corto de la oferta (no repetir la lista completa de contenidos). */
export const OFFER_INCLUDES: string[] = [
  '4 tomos digitales',
  '200 fórmulas paso a paso',
  '5 libros extra de regalo',
  'Acceso digital inmediato',
]

export const FAQS: Faq[] = [
  {
    q: '¿Necesito experiencia haciendo jabones?',
    a: 'No. El material empieza por los fundamentos de la base de glicerina y avanza hacia técnicas más elaboradas.',
  },
  {
    q: '¿Necesito equipamiento profesional?',
    a: 'No. Muchas fórmulas se resuelven con moldes, utensilios e insumos básicos de fabricación artesanal.',
  },
  {
    q: '¿Se trabaja con sosa cáustica?',
    a: 'No. Todas las fórmulas parten de base de glicerina lista para fundir y moldear, sin saponificación desde cero.',
  },
  {
    q: '¿Tengo que hacer las 200 fórmulas?',
    a: 'No. Funcionan como una biblioteca de consulta: elegís las que se adaptan a lo que querés fabricar.',
  },
  {
    q: '¿Los 5 libros extra están incluidos?',
    a: 'Sí. Los 5 libros de regalo vienen gratis con la compra, sin costo adicional.',
  },
  {
    q: '¿Cómo lo recibo?',
    a: 'Es un producto digital. Después de la compra recibís el acceso para descargar los 4 tomos y los 5 libros extra.',
  },
  {
    q: '¿El pago es único?',
    a: 'Sí. $19.990 ARS en un único pago, sin suscripciones.',
  },
]
